// TokenLogo.js
import React from 'react';

export default function TokenLogo() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 200 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block' }}
    >
      <defs>
        <radialGradient id="metalGradient" cx="0.5" cy="0.5" r="0.6">
          <stop offset="0%" stopColor="#4A90E2" />
          <stop offset="100%" stopColor="#1B3F8B" />
        </radialGradient>
        <filter id="innerShadow" x="0" y="0" width="200%" height="200%">
          <feDropShadow
            dx="0"
            dy="0"
            stdDeviation="5"
            floodColor="#14315B"
            floodOpacity="0.7"
          />
        </filter>
      </defs>

      <circle
        cx="100"
        cy="100"
        r="95"
        fill="url(#metalGradient)"
        filter="url(#innerShadow)"
      />
      <circle cx="100" cy="100" r="85" fill="#D8E6FF" />
      <ellipse cx="70" cy="100" rx="50" ry="30" fill="#2F80ED" fillOpacity="0.8" />
      <ellipse cx="130" cy="100" rx="50" ry="30" fill="#56CCF2" fillOpacity="0.8" />
      <circle cx="70" cy="100" r="12" fill="#fff" />
      <circle cx="130" cy="100" r="12" fill="#fff" />
      <circle cx="100" cy="70" r="8" fill="#2F80ED" />
      <circle cx="100" cy="130" r="8" fill="#56CCF2" />
      <line x1="70" y1="100" x2="100" y2="70" stroke="#4A90E2" strokeWidth="3" />
      <line x1="130" y1="100" x2="100" y2="70" stroke="#4A90E2" strokeWidth="3" />
      <line x1="70" y1="100" x2="100" y2="130" stroke="#56CCF2" strokeWidth="3" />
      <line x1="130" y1="100" x2="100" y2="130" stroke="#56CCF2" strokeWidth="3" />
      <circle
        cx="100"
        cy="100"
        r="95"
        stroke="#14315B"
        strokeWidth="5"
        strokeDasharray="4 8"
        fill="none"
      />
    </svg>
  );
}
